import '../App.css';
import Calculator from '../components/calculator';

function MyCalc() {
  return (
    <div className="#">
      <Calculator />
    </div>
  );
}

export default MyCalc;
